import { request as openRequest } from './reducers/open';
import { request as queryRequest } from './reducers/query';
import { request as getRequest } from './reducers/get';

export default {
    AUDITS_QUERY_REQUEST: queryRequest,
    AUDITS_OPEN_REQUEST: openRequest,
    AUDIT_REQUEST: getRequest
};
